import { render } from "./ModalPhoto.vue?vue&type=template&id=3b2697d4"
import script from "./ModalPhoto.vue?vue&type=script&lang=js"
export * from "./ModalPhoto.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__